import { Link } from "react-router-dom";

export const Logo = ({ light = false, onClick }) => (
  <Link to="/" onClick={onClick} className="group flex shrink-0 items-center" data-testid="logo-home-link" aria-label="Good Home Improvement LLC home">
    <img
      src={light ? "/logo-light.png" : "/logo-dark.png"}
      alt="Good Home Improvement LLC"
      className="h-12 w-auto transition-transform duration-500 group-hover:scale-[1.03] sm:h-14"
      data-testid="logo-image"
    />
  </Link>
);
